import React, { useState, useEffect } from "react";
import TimesheetList from "../../components/timesheet/TimesheetList";
import TimesheetDetails from "../../components/timesheet/TimesheetDetails";
import "../../assets/css/timesheet.css";
import NavBar from "../../components/general/NavBarApp";
import download from "../../assets/img/ico/download.svg";
import {Link, useNavigate} from 'react-router-dom';
import NavBarApp from "../../components/general/NavBarApp";

// Exemple de données
const timesheetsData = [
  {
    id: 1,
    date: "Jeu. 30 Mars 2025",
    name: "Lucas Prochon",
    role: "Cuisinier H/F",
    status: "À FAIRE",
    startTime: "05:30",
    endTime: "13:00",
    breakTime: "00:30",
    workedHours: "07:00",
  },
  {
    id: 2,
    date: "Ven. 31 Mars 2025",
    name: "Marie Dupont",
    role: "Serveuse H/F",
    status: "À FAIRE",
    startTime: "06:00",
    endTime: "14:00",
    breakTime: "00:45",
    workedHours: "07:15",
  },
  {
    id: 3,
    date: "Sam. 1 Avril 2025",
    name: "Jean Martin",
    role: "Plongeur H/F",
    status: "À FAIRE",
    startTime: "07:00",
    endTime: "15:00",
    breakTime: "01:00",
    workedHours: "07:00",
  },
  {
    id: 4,
    date: "Dim. 2 Avril 2025",
    name: "Sophie Bernard",
    role: "Chef H/F",
    status: "ARCHIVE",
    startTime: "08:00",
    endTime: "16:00",
    breakTime: "00:30",
    workedHours: "07:30",
  },
  {
    id: 5,
    date: "Lun. 3 Avril 2025",
    name: "Paul Durand",
    role: "Cuisinier H/F",
    status: "À FAIRE",
    startTime: "05:30",
    endTime: "13:30",
    breakTime: "00:30",
    workedHours: "07:30",
  },
  {
    id: 6,
    date: "Mar. 4 Avril 2025",
    name: "Emma Leroy",
    role: "Serveuse H/F",
    status: "À FAIRE",
    startTime: "06:30",
    endTime: "14:30",
    breakTime: "00:45",
    workedHours: "07:15",
  },
  {
    id: 7,
    date: "Mer. 5 Avril 2025",
    name: "Lucas Morel",
    role: "Plongeur H/F",
    status: "À FAIRE",
    startTime: "07:30",
    endTime: "15:30",
    breakTime: "01:00",
    workedHours: "07:00",
  },
];

function TimesheetPage() {
  const [selectedTimesheet, setSelectedTimesheet] = useState(timesheetsData[0]);
  const [timesheetItems, setTimesheetItems] = useState(timesheetsData);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);
  // Gère le redimensionnement
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1100);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const calculateWorkedHours = (startTime, endTime, breakTime) => {
    const [startHours, startMinutes] = startTime.split(":").map(Number);
    const [endHours, endMinutes] = endTime.split(":").map(Number);
    const [breakHours, breakMinutes] = breakTime.split(":").map(Number);

    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const breakTotalMinutes = breakHours * 60 + breakMinutes;

    const workedMinutes =
      endTotalMinutes - startTotalMinutes - breakTotalMinutes;

    const workedHours = Math.floor(workedMinutes / 60);
    const workedMinutesRemainder = workedMinutes % 60;

    return `${String(workedHours).padStart(2, "0")}:${String(
      workedMinutesRemainder
    ).padStart(2, "0")}`;
  };

  const handleUpdateItem = (updatedItem) => {
    const updatedWorkedHours = calculateWorkedHours(
      updatedItem.startTime,
      updatedItem.endTime,
      updatedItem.breakTime
    );

    const updatedTimesheet = {
      ...updatedItem,
      workedHours: updatedWorkedHours,
    };

    setSelectedTimesheet(updatedTimesheet);
    setTimesheetItems((prevItems) =>
      prevItems.map((item) =>
        item.id === updatedTimesheet.id ? updatedTimesheet : item
      )
    );
  };

  const handleDeselect = () => {
    setSelectedTimesheet(null);
  };

  const showList = !isMobile || (isMobile && !selectedTimesheet);
  const showDetails = !isMobile || (isMobile && selectedTimesheet);

  const [selected, setSelected] = useState("Ce mois");
  const [open, setOpen] = useState(false);

  const options = ["90 derniers jours", "6 derniers mois", "Ce mois"];

  const handleSelect = (value) => {
    setSelected(value);
    setOpen(false);
    // ici tu pourrais trier ton tableau offer selon la valeur choisie
  };

  const [selectedDateRange, setSelectedDateRange] = useState(
    "Sam.01 mars.25 - Dim.02 mars.25"
  );

  return (
    <div className="main">
      <NavBarApp userType="entreprise" />
      <section className="timesheet-section">
        <div className="financial-header">
          <div className="header-title">
            <h3>Relevés d'heure</h3>{" "}
            {/* Utilise H1 ou H2 selon la structure globale */}
          </div>

          <div className="header-controls">
            <div className="filter-group">
              <label htmlFor="period-select" className="filter-label">
                Trier par
              </label>

              <div className="custom-dropdown" onClick={() => setOpen(!open)}>
                <button className="custom-dropdown-button">
                  {selected}
                  <i
                    className={`fa-solid fa-chevron-down ${
                      open ? "rotate" : ""
                    }`}
                  ></i>
                </button>

                {open && (
                  <ul className="custom-dropdown-menu">
                    {options.map((option) => (
                      <li
                        key={option}
                        onClick={() => handleSelect(option)}
                        className={`custom-dropdown-item ${
                          selected === option ? "active" : ""
                        }`}
                      >
                        {option}
                        {selected === option && (
                          <i className="fa-solid fa-check check-icon"></i>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="filter-group">
              {/* Placeholder pour le sélecteur de date range */}
              {/* Idéalement, remplace ceci par un composant de date picker */}
              <input
                type="text" // Utilise un type 'date' ou une librairie de date picker
                value={selectedDateRange} // Utilise la prop
                onChange={(e) => setSelectedDateRange(e.target.value)} // Utilise la prop
                // Si état local : value={localSelectedDateRange} onChange={(e) => setLocalSelectedDateRange(e.target.value)}
                className="date-range-picker"
                placeholder="Sélectionner une plage de dates"
              />
              {/* Icône de calendrier ici */}
            </div>

            <div>
              <Link to={"/mission-creation"}
                    className="btn fill green"
              >
                Commander une nouvelle mission
              </Link>
            </div>
          </div>
        </div>
        <div className="timesheet-container">
          {showList && (
            <TimesheetList
              timesheets={timesheetsData}
              onSelect={setSelectedTimesheet}
              selectedId={selectedTimesheet?.id}
            />
          )}
          {showDetails && (
            <TimesheetDetails
              timesheet={selectedTimesheet}
              onUpdate={handleUpdateItem}
              onDeselect={handleDeselect}
            />
          )}
        </div>
      </section>
    </div>
  );
}

export default TimesheetPage;
